export interface IUserAccessRoles {
  id: string;
  title: UserAccessLevelTitle;
  value: UserAccessLevel;
}

export enum UserAccessLevel {
  User = 'user',
  Chief = 'chief'
}

export enum UserAccessLevelTitle {
  User = 'Accountant',
  Chief = 'Admin'
}

export enum AccountantActions {
  Edit = 'edit',
  Delete = 'delete',
}

export enum UserRole {
  Deactivated = 'deactivated',
  User = 'user',
  Manager = 'manager',
  Invited = 'invited',
  Accountant = 'accountant',
  InvitedAccountant = 'invited_accountant',
}

export type FirmMarketsType = Array<number>;

export interface ITeamMembersFilters {
  search: string | null;
}
